import { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import axios from 'axios';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { TZ as APP_TIMEZONE } from '../config/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);
const TZ = APP_TIMEZONE || 'America/Chicago';

const EVENT_API_URL = '/api/events';

const FormWithLocalStorage = ({ onEventAdded }) => {
  const [inputs, setInputs] = useState({});

  // Calculate and set default values on mount
  useEffect(() => {
    const now = dayjs().tz(TZ);
    const currentHour = now.hour();

    // Determine start date (today, or tomorrow if >= 8pm) in TZ
    let startDate = now;
    if (currentHour >= 20) {
      startDate = startDate.add(1, 'day');
    }
    const startDateStr = startDate.format('YYYY-MM-DD');
    
    // Determine start time (next closest hour + 1 hour, or 10am next day if >= 8pm)
    let startHour;
    if (currentHour >= 20) {
      startHour = 10;
    } else {
      startHour = Math.ceil(currentHour + 1);
      if (startHour > 23) startHour = 0;
    }
    const startTimeStr = `${String(startHour).padStart(2, '0')}:00`;
    
    // Determine end time (2 hours after start time)
    let endHour = (startHour + 2) % 24;
    const endTimeStr = `${String(endHour).padStart(2, '0')}:00`;
    
    // End date defaults to same as start date
    const endDateStr = startDateStr;
    
    setInputs({
      testevent: '',
      year: startDateStr,
      endDate: endDateStr,
      startTime: startTimeStr,
      endTime: endTimeStr
    });
  }, []);

  const handleChange = (event) => {
    const fieldName = event.target.name;
    const fieldValue = event.target.value;
    // When start date changes and is after end date, update end date
    if (fieldName === 'year' && inputs.endDate && fieldValue > inputs.endDate) {
      setInputs(values => ({ ...values, [fieldName]: fieldValue, endDate: fieldValue }));
    } else {
      setInputs(values => ({ ...values, [fieldName]: fieldValue }));
    }
  };

  const handleClick = async (event) => {
    event.preventDefault();
    const eventData = {
      name: inputs.testevent,
      date: inputs.year,
      endDate: inputs.endDate,
      startTime: inputs.startTime,
      endTime: inputs.endTime,
      email: inputs.email,
      location: inputs.location
    };
    try {
      const response = await axios.post(EVENT_API_URL, eventData);
      console.log('Event added:', response.data);
      setInputs({});
      if (onEventAdded) onEventAdded();
    } catch (error) {
      console.error('Error adding event:', error);
    }
  };

  return (
    <div className="form-card">
      <Form className="event-form">
        <div className="form-header">
          <h2 className="form-title">Book your next vibe.</h2>
        </div>
        <InputGroup className="form-field mb-3">
          <InputGroup.Text>Event</InputGroup.Text>
          <Form.Control
            placeholder="Event name"
            type="text"
            name="testevent"
            value={inputs.testevent || ''}
            onChange={handleChange}
            className="form-input"
          />
        </InputGroup>
        <InputGroup className="mb-3">
          <InputGroup.Text>Date</InputGroup.Text>
          <FloatingLabel label="Start Day">
          <Form.Control
            type="date"
            name="year"
            value={inputs.year || ''}
            onChange={handleChange}
          />
          </FloatingLabel>
          <FloatingLabel label="End Day">
          <Form.Control
            type="date"
            name="endDate"
            value={inputs.endDate || ''}
            onChange={handleChange}
          />
          </FloatingLabel>
        </InputGroup>

        <InputGroup className="form-floating mb-3">
          <InputGroup.Text>Time</InputGroup.Text>
          <FloatingLabel label="Start Time">
            <Form.Control
              type="time"
              name="startTime"
              value={inputs.startTime || ''}
              onChange={handleChange}
            />
          </FloatingLabel>
          <FloatingLabel label="End Time">
            <Form.Control
              type="time"
              name="endTime"
              value={inputs.endTime || ''}
              onChange={handleChange}
            />
          </FloatingLabel>
        </InputGroup>

         <InputGroup className="mb-3">
          <InputGroup.Text>Location</InputGroup.Text>
          <Form.Control
            placeholder="Location"
            type="text"
            name="location"
            value={inputs.location || ''}
            onChange={handleChange}
          />
        </InputGroup>

        <InputGroup className="form-field mb-3">
          <InputGroup.Text>Email</InputGroup.Text>
          <Form.Control
            placeholder="Email"
            type="email"
            name="email"
            value={inputs.email || ''}
            onChange={handleChange}
            className="form-input"
          />
        </InputGroup>

        <Button className="form-badge" onClick={handleClick}>
          Create chill
        </Button>
      </Form>
    </div>
  );
};

export default FormWithLocalStorage;







